import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  HIDE_MODAL,
  SHOW_REGISTER,
  SHOW_LOGIN,
  SHOW_MODAL,
  CHECK_EMAIL_STATUS,
} from "../actions/types";
import { getUserFromStorage } from "services/storage-utils";

const user = getUserFromStorage();

const initialState = {
  isLoggedIn: user ? true : false,

  user: user ? user : null,
  // Show register/login modal
  // showModal: false,
  // // if isMember === true  => we show login , else => register
  // isMember: false,
};

function auth(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case REGISTER_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isLoggedIn: false,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      };
    case CHECK_EMAIL_STATUS:
      return {
        ...state,
        isLoggedIn: payload.is_verified,
      };
    // case SHOW_REGISTER:
    //   return {
    //     ...state,
    //     showModal: true,
    //     isMember: false,
    //   };
    // case SHOW_LOGIN:
    //   return {
    //     ...state,
    //     showModal: true,
    //     isMember: true,
    //   };
    // case HIDE_MODAL:
    //   return {
    //     ...state,
    //     showModal: false,
    //   };
    // case SHOW_MODAL:
    //   return {
    //     ...state,
    //     showModal: true,
    //   };
    default:
      return state;
  }
}

export default auth;
